import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import API from "../../api/axiosConfig";
//import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";


function Hcvendor(props) {

    const columns = [
        { name: "إسم المورد", key: "name" },
        { name: "  العنوان", key: "address" },
        { name: "رقم الجوال", key: "phone" },
        { name: "البريد الالكتروني", key: "email" },
        { name: "النوع", key: "type" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());

    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const dropdownOptions = [
        { label: "تعديل", route: "/edithcvendor/:id" },
        { label: "حذف", action: (id) => {
            if (window.confirm("هل أنت متأكد من حذف هذا المورد؟")) {
                API.get(`/humancasevendor/${id}/delete`)
                    .then((res) => {
                        if (res.status === 200) {
                            setTableReloadKey(Date.now());
                        }
                    })
                    .catch((error) => {
                        console.error("There was an error!", error);
                    });
            }
        } },
    ];

    return (
        <>
            <div className="printcasedata-container">

                <TableComponent
                    apiUrl="/humancasevendor"
                    columns={columns}
                    title="تقرير الموردون"
                    titleIcon={<FontAwesomeIcon icon={faReceipt} />}
                    dropdownOptions={dropdownOptions}
                    searchDate={false}
                    placeholderSearch='إسم المورد'
                    tableReloadKey={tableReloadKey}
                />
            </div>
        </>
    );
}

export default Hcvendor;
